import { RestSchemas } from '@/contexts/QueryProvider'

export type MessagesStorageStorageDetailItemWorkspace = RestSchemas['Messages.Storage.StorageDetailItemWorkspace']

const OCTET_STREAM_CONTENT_TYPE = 'application/octet-stream'
const HIDDEN_WORKSPACE_PROPERTY_KEYS = new Set(['is_directory'])

function getLastPathSegment(path: string) {
  const segments = path.split('/').filter(Boolean)
  return segments[segments.length - 1] ?? ''
}

function hasFileExtension(pathSegment: string) {
  const extensionSeparatorIndex = pathSegment.lastIndexOf('.')
  return extensionSeparatorIndex > 0 && extensionSeparatorIndex < pathSegment.length - 1
}

export function isWorkspaceDirectory(item: MessagesStorageStorageDetailItemWorkspace) {
  const blobNameLeaf = getLastPathSegment(item.blobName) || item.filename

  return !hasFileExtension(blobNameLeaf) && item.size === 0 && item.contentType === OCTET_STREAM_CONTENT_TYPE
}

export function getVisibleWorkspaceProperties(item: MessagesStorageStorageDetailItemWorkspace) {
  return Object.entries(item.properties).filter(([key]) => !HIDDEN_WORKSPACE_PROPERTY_KEYS.has(key))
}
